module.exports = __webpack_public_path__ + "static/media/chart-bar.dee36a18.svg";